export const API_URL = process.env.REACT_APP_API_URL;

export const ANALYTICS_URL = process.env.REACT_APP_ANALYTICS_URL;
export const ANALYTICS_REPORTS_URL = process.env.REACT_APP_ANALYTICS_REPORTS_URL;
export const CLIENT_PHI_URL = process.env.REACT_APP_CLIENT_PHI_URL;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const QA_TOKEN = process.env.REACT_APP_QA_TOKEN;
export const getAuthV3BaseUrl = () => (API_URL ? `${new URL(API_URL).origin}/api/v3` : '');
